/**
 * The watchlist (Phase 2). A set of marketplace listing ids the user is following.
 *
 * Client-side and local for now: it lives in localStorage and is not personal data or a value action,
 * so it does not need the backend during the UI-first phase. When the backend is wired, this becomes a
 * thin wrapper over a `/watchlist` endpoint and the storage key becomes a cache. A window event lets
 * every mounted WatchButton and the Watchlist page stay in sync without prop drilling.
 */

const KEY = 'lipa.watchlist';
const EVENT = 'lipa:watchlist-change';

export function getWatchlist(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function isWatched(id: string): boolean {
  return getWatchlist().includes(id);
}

export function toggleWatch(id: string): boolean {
  const current = getWatchlist();
  const next = current.includes(id) ? current.filter((x) => x !== id) : [...current, id];
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVENT));
  } catch {
    /* storage blocked: the toggle just will not persist */
  }
  return next.includes(id);
}

/** Subscribe to changes (from any WatchButton, or another tab). Returns an unsubscribe function. */
export function onWatchlistChange(fn: () => void): () => void {
  window.addEventListener(EVENT, fn);
  window.addEventListener('storage', fn);
  return () => {
    window.removeEventListener(EVENT, fn);
    window.removeEventListener('storage', fn);
  };
}
